import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { PropertySegments } from "./components/PropertySegments";
import { FeaturedProperties } from "./components/FeaturedProperties";
import { MVDASection } from "./components/MVDASection";
import { WhyChooseUs } from "./components/WhyChooseUs";
import { Locations } from "./components/Locations";
import { Footer } from "./components/Footer";
import { Toaster } from "./components/ui/sonner";

const Home = () => {
  return (
    <div>
      <Header />
      <Hero />
      <PropertySegments />
      <FeaturedProperties />
      <MVDASection />
      <WhyChooseUs />
      <Locations />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
